import { render } from "./AddNotesArea.vue?vue&type=template&id=15cf2539&ts=true"
import script from "./AddNotesArea.vue?vue&type=script&lang=ts"
export * from "./AddNotesArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__